import ActionFactory from '../actions/ActionFactory';

const createAsyncActionTypes = typeNames => (
  typeNames.map(type => Object.values(ActionFactory(type))).flat()
);

export default createAsyncActionTypes;



// WEBPACK FOOTER //
// ./src/utils/createAsyncActionTypes.js